import { Component, Input } from '@angular/core';
import {
  SystemNotificationsService,
  ISystemNotification,
} from './system-notifications.provider';
import { BrandService } from '../../services/brand.service';
import { UtilityService } from '../../services/utility.service';
import { ConfigService } from '../../services/configuration.service';
import { StringService } from '../../services/string.service';

enum MessageType {
  ALERT = 'alert',
  INFORMATION = 'info',
}

@Component({
  selector: 'system-notifications',
  templateUrl: './system-notifications.component.html',
})
export class SystemNotificationsComponent {
  @Input()
  set location(newLocation: string) {
    if (!newLocation) {
      return;
    }

    this._location = newLocation;
    this.setNotificationsForLocation(this._location);
  }

  notifications: ISystemNotification[];

  typeAlertMapping: { [key: string]: string } = {
    [MessageType.ALERT]: 'error',
    [MessageType.INFORMATION]: 'information',
  };

  private _location: string;
  private allNotifications: ISystemNotification[];
  private isMobile: boolean;

  constructor(
    private systemNotificationService: SystemNotificationsService,
    private brandService: BrandService,
    private utilityService: UtilityService,
    configService: ConfigService
  ) {
    this.isMobile = configService.Get('mobileView');
    this.loadNotifications();
  }

  private setNotificationsForLocation(location: string): void {
    if (!this.allNotifications || !location) {
      return;
    }

    this.notifications = this.allNotifications
      .filter((n) => n.location.includes(location))
      .map(this.processMessage.bind(this));
  }

  private processMessage(
    notification: ISystemNotification
  ): ISystemNotification {
    if (this.isMobile) {
      this.adjustMessageForMobile(notification);
    }

    this.fillBrandVariables(notification);
    this.createUniqueMessageName(notification);

    return notification;
  }

  private fillBrandVariables(
    notification: ISystemNotification
  ): ISystemNotification {
    notification.message = notification.message.replace(
      /\[brand\]/g,
      this.brandService.getBrand()
    );

    return notification;
  }

  private createUniqueMessageName(
    notification: ISystemNotification
  ): ISystemNotification {
    notification.uniqueName =
      notification.dismissType +
      SystemNotificationsService.COOKIE_PART +
      StringService.hashCode(notification.message);

    return notification;
  }

  private adjustMessageForMobile(
    notification: ISystemNotification
  ): ISystemNotification {
    notification.message = this.utilityService.stripHtmlTags(
      notification.message,
      'a'
    );

    return notification;
  }

  private loadNotifications(): void {
    this.systemNotificationService
      .getSystemNotifications()
      .then((notifications) => {
        this.allNotifications = notifications;
        this.setNotificationsForLocation(this._location);
      });
  }
}
